export default __webpack_public_path__ + "static/media/ULSticker.b185f362.svg";